import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from 'common/components/modules/video-player';

import {
   BigPlayButton,
   ControlBar,
   // PlayToggle,
   // ProgressControl,
   VolumeMenuButton,
} from 'video-react';

import Header from 'common/components/modules/story-player/header';
import Bottom from 'common/components/modules/story-player/bottom';

import './configure-player-styles.scss';
import '../../style.scss';

const VideoContent = ({
   src,
   poster,
   title,
   date,
   timeLeft,
   timeSector,
   commentsCount,
   startTime,

   muted,
   controls,
   autoPlay,
   loop,
   bigPlayButton,
   controlBar,
   autoHideControlBar,
   disableDefaultControls,
   showTimeLeft,
   hasAccess,

   isLiked,
   onClose,
   onErrorStateChange,
   onClickComment,
   onClickLike,
   onClickShare,
   onDeleteStory,
   isAdmin,
   hideAfterMinutes,
   isAuthUsers,
   hideButtonContent,
   headerBottomPosition,
   openFullScreenCard,
   onClickTip,
   id,
   onClickOpenTips,
   onClickSetId,
   totalTip,
   onFullScreenClose,
   onShare,
   isShowPage,
   onEditStory,
   pinStory,
   isPinned,
   isDemoMode,
   showComments,
}) => {
   const [paused, changePaused] = useState(false);
   return (
      <VideoPlayer
         width={ 100 }
         height={ 80 }
         poster={ poster }
         // TODO feature change for multiply quality sources
         src={ src }
         muted={ muted }
         controls={ controls }
         autoPlay={ true }
         // fullscreen={ true }
         // isFullscreen={ true }
         playsInline={ true }
         startTime={ startTime }
         loop={ loop }
         onErrorStateChange={ onErrorStateChange }
         onPause={ () => {
            if(!paused) {
               changePaused(true);
            }
         } }
         onPlay={ () => {
            if(paused) {
               changePaused(false);
            }
         } }
      >
         <Header
            showTimeLeft={ showTimeLeft }
            handleClose={ onFullScreenClose || onClose }
            title={ paused ? title : '' }
            timeLeft={ timeLeft }
            date={ paused ? date : '' }
            timeSector={ timeSector }
            hideAfterMinutes={ hideAfterMinutes }
            fixed={ true }
            position={ headerBottomPosition }
         />
         <BigPlayButton
            position='center'
            className='player_bigPlayButton border-none'
         />
         <ControlBar
            autoHide={ autoHideControlBar }
            disableDefaultControls={ false }
            className={ `customize-control-bar ${ paused ? "paused" : '' }` }
         >
            {/* <PlayToggle
               className='viewVideo_playToggle h-12 ams-icon'
            />
            <ProgressControl
               className='viewVideo_progressControl'
            /> */}
            <VolumeMenuButton />
            {/* Custom component start */}
            {/* Custom component end */}
         </ControlBar>
         {
            paused && !hideButtonContent && (
               <Bottom
                  hasAccess={ hasAccess }
                  isLiked={ isLiked }
                  commentsCount={ commentsCount }
                  onClickComment={ onClickComment }
                  onClickLike={ onClickLike }
                  onClickShare={ onClickShare }
                  position='absolute'
                  isAdmin={ isAdmin }
                  isAuthUsers={ isAuthUsers }
                  onDeleteStory={ onDeleteStory }
                  openFullScreenCard={ openFullScreenCard }
                  onClickTip={ onClickTip }
                  id={ id }
                  onTipOpen={ onClose }
                  onClickOpenTips={ onClickOpenTips }
                  onClickSetId={ onClickSetId }
                  totalTip={ totalTip }
                  onShare={ (id, type) => onShare(id, type, title || 'story') }
                  isShowPage={ isShowPage }
                  onEditStory={ onEditStory }
                  pinStory={ pinStory }
                  isPinned={ isPinned }
                  isDemoMode={ isDemoMode }
                  showComments={ showComments }
               />
            )
         }

      </VideoPlayer>
   );
};
VideoContent.defaultProps = {
   hideButtonContent: false,
}
VideoContent.propTypes = {
   src: PropTypes.string,
   poster: PropTypes.string,
   title: PropTypes.string,
   date: PropTypes.string,
   timeLeft: PropTypes.string,
   timeSector: PropTypes.number,
   commentsCount: PropTypes.number,
   startTime: PropTypes.number,

   muted: PropTypes.bool,
   controls: PropTypes.bool,
   autoPlay: PropTypes.bool,
   loop: PropTypes.bool,
   bigPlayButton: PropTypes.bool,
   controlBar: PropTypes.bool,
   autoHideControlBar: PropTypes.bool,
   disableDefaultControls: PropTypes.bool,
   showTimeLeft: PropTypes.bool,
   hasAccess: PropTypes.bool,
   isLiked: PropTypes.bool,
   isAdmin: PropTypes.bool,
   isAuthUsers: PropTypes.bool,

   onClose: PropTypes.func,
   onErrorStateChange: PropTypes.func,
   onClickComment: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickShare: PropTypes.func,
   onDeleteStory: PropTypes.func,
   hideButtonContent: PropTypes.bool,
   headerBottomPosition: PropTypes.string,
   hideAfterMinutes: PropTypes.number,
   openFullScreenCard: PropTypes.func,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   totalTip: PropTypes.number,
   onFullScreenClose: PropTypes.func,
   onShare: PropTypes.func,
   isShowPage: PropTypes.bool,
   onEditStory: PropTypes.func,
   pinStory: PropTypes.func,
   isPinned: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   showComments: PropTypes.bool,
};

export default memo(VideoContent);
